import React, { useContext, useState } from "react";
import { Avatar, Icon } from "antd";
import { NavLink, Link } from "react-router-dom";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";

import logo from "../images/logo.svg";
import { UserContext } from "../context/context";

function Menubar() {
  const context = useContext(UserContext);
  const { isSignin, user } = context;
  const [isExpand, setIsExpand] = useState(false);
  return (
    <NavWrapper>
      <Logo to="/">
        <img
          src={logo}
          alt="Ticktick"
          style={{ width: "22px", marginRight: "8px" }}
        />
        <span>Developer</span>
      </Logo>
      <Main isExpand={isExpand}>
        <NavItem
          to="/docs#/openapi"
          activeStyle={{ color: "#4772FA" }}
          exact
          onClick={() => {
            setIsExpand(false);
          }}
        >
          <FormattedMessage id="nav_api" />
        </NavItem>
        <NavItem
          to="/manage"
          activeStyle={{ color: "#4772FA" }}
          onClick={() => {
            setIsExpand(false);
          }}
        >
          <FormattedMessage id="nav_manageApp" />
        </NavItem>
        {isSignin ? (
          <UserWrapper>
            <CustomAvator size="small" icon="user" src={user.avatarUrl} />
            {user.name || ""}
          </UserWrapper>
        ) : null}
      </Main>
      <NavTrigger
        type="menu"
        onClick={() => {
          setIsExpand(!isExpand);
        }}
      />
    </NavWrapper>
  );
}

export default Menubar;

const NavWrapper = styled.div`
  background: #ffffff;
  display: flex;
  position: relative;
  justify-content: space-between;
  height: 100%;
  align-items: center;
  padding: 0 15px;
  border-bottom: 1px solid #ededed;
`;

const Main = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: right;
  font-weight: 500;
  @media (max-width: 650px) {
    transition: opacity 0.25s ease, transform 0.25s ease;
    flex-direction: column;
    position: absolute;
    background: #ffffff;
    z-index: -1;
    top: 64px;
    left: 0;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    ${(props) =>
      !props.isExpand
        ? "opacity: 0; transform: translateY(-1rem); pointer-events: none;"
        : "opacity: 1; transform: none;"}
  }
  > * {
    @media (max-width: 650px) {
      height: 64px;
      width: 100%;
      margin: 0 !important;
      text-align: center;
      line-height: 64px !important;
      border-bottom: 1px solid #eaeaea;
      box-sizing: padding-box;
    }
  }
`;

const Logo = styled(Link)`
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
  min-width: 95px;
  font-size: 14px;
  position: relative;
  z-index: 99;
`;

const NavItem = styled(NavLink)`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 22px;
  &:not(:nth-last-child(1)) {
    margin-right: 64px;
  }
`;

const NavTrigger = styled(Icon)`
  display: none;
  @media (max-width: 650px) {
    display: block;
  }
`;

const UserWrapper = styled.div`
  * {
    font-weight: 500;
  }
`;

const CustomAvator = styled(Avatar)`
  margin-right: 8px;
  @media (max-width: 650px) {
    display: none;
  }
`;
